import { render, staticRenderFns } from "./TeacherWelcome.vue?vue&type=template&id=0022bd48&scoped=true"
import script from "./TeacherWelcome.vue?vue&type=script&lang=js"
export * from "./TeacherWelcome.vue?vue&type=script&lang=js"
import style0 from "./TeacherWelcome.vue?vue&type=style&index=0&id=0022bd48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022bd48",
  null
  
)

export default component.exports